import { makeAutoObservable } from 'mobx';
import {
  DownloadedFileExtension,
  FILE_EXTENSION,
} from '../../shared/constants/file/FILE_EXTENSIONS';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { salesReportService } from '../services/salesReportService';
import { ReportInfo } from '../interfaces/ReportInfo';
import { DownloadParams } from '../interfaces/DownloadParams';

class SalesReportStore {
  reports: ReportInfo[] = [];
  isShowDownloadModal: boolean = false;
  selectedReport: ReportInfo | null = null;
  fileExtension: DownloadedFileExtension | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.reports = [];
    this.isShowDownloadModal = false;
    this.selectedReport = null;
    this.fileExtension = null;
  }

  async getReports() {
    const { reports } = await salesReportService.getReports();

    this.setReports(reports);
  }

  setReports(reports: ReportInfo[]) {
    this.reports = reports;
  }

  openDownloadModal(selectedReport: ReportInfo, fileExtension: DownloadedFileExtension) {
    this.setIsShowDownloadModal(true);
    this.setSelectedReport(selectedReport);
    this.setFileExtension(fileExtension);
  }

  setIsShowDownloadModal(isShowDownloadModal: boolean) {
    this.isShowDownloadModal = isShowDownloadModal;
  }

  setSelectedReport(selectedReport: ReportInfo | null) {
    this.selectedReport = selectedReport;
  }

  setFileExtension(fileExtension: DownloadedFileExtension | null) {
    this.fileExtension = fileExtension;
  }

  closeDownloadModal() {
    this.setIsShowDownloadModal(false);
    this.setSelectedReport(null);
    this.setFileExtension(null);
  }

  downloadReport(params: DownloadParams) {
    if (!this.selectedReport) return;

    const { reportType } = this.selectedReport;

    if (this.fileExtension === FILE_EXTENSION.CSV) {
      salesReportService.downloadReportCSV(reportType, params);
    } else {
      salesReportService.downloadReportPDF(reportType, params);
    }

    this.closeDownloadModal();
  }
}

const salesReportStore = new SalesReportStore();

resetAllStore.addResetMethod(salesReportStore.setDefaultValues);

export { SalesReportStore, salesReportStore };
